var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GlobalEvents',{attrs:{"target":"window"},on:{"offline":_vm._showOfflineMessage,"online":_vm._showOnlineMessage}})}
var staticRenderFns = []

export { render, staticRenderFns }